<div class="p-4">
	<div class="demo-container">
		<div class="title">Auto Create All</div>
		<select class="form-select" [(ngModel)]="selectedTask" data-testid="create-checklists-selected-task">
			<option *ngFor="let action of actions" [ngValue]="action">{{ action.label }}</option>
		</select>
		<button type="button" class="btn btn-primary btn-sm ml-2" (click)="runSelectedTask()"
			*ngIf="!creatingChecklists" data-testid="create-checklists-create">
			Create
		</button>
		<br />
		<br />
		<span class="text-primary" *ngIf="checklistCount">{{ checklistCount }} Checklists created!
			<i class="fa-duotone fa-face-awesome"></i> See console log for more
			info.</span>
		<div class="text-primary" role="status" *ngIf="creatingChecklists">
			<i class="fa-regular fa-dice-d20 fa-spin fa-3x"></i>
		</div>
	</div>
	<br />
	<div class="demo-container">
		<div class="title">Create Individual</div>
		<div class="row" *ngIf="!isRunningChecklistBuild">
			<div class="col-2 text-right">Checklist Name</div>
			<div class="col-2">Amount</div>
			<div class="col-1">
				Company ID<span *ngIf="!checklistUseOneCompany">s (put each # on a new line)</span>
			</div>
			<div class="col-1">Start Month</div>
			<div class="col-1">Term</div>
			<div class="col-1">End Month</div>
			<div class="col-1">Due Date</div>
		</div>
		<hr />
		<div class="row m-1" *ngIf="!isRunningChecklistBuild">
			<div class="col-2 text-right">IFTA Miles/Fuel Entry</div>
			<select class="col-2" [(ngModel)]="checklistUseOneCompany"
				data-testid="create-checklists-checklist-use-one-company">
				<option [ngValue]="true">One Company</option>
				<option [ngValue]="false">Many Companies</option>
			</select>
			<input class="col-1" *ngIf="checklistUseOneCompany" type="number" [(ngModel)]="checklistCompanyId"
				data-testid="create-checklists-checklist-company-id-number" />
			<textarea class="col-1" *ngIf="!checklistUseOneCompany" [(ngModel)]="checklistListOfCompanies"
				data-testid="create-checklists-checklist-list-companies"></textarea>
			<input class="col-1" type="date" [(ngModel)]="checklistStartDate" (change)="makeFirstOfMonth()"
				data-testid="create-checklists-checklist-start-date" />
			<select class="col-1" [(ngModel)]="checklistTermType" (change)="makeFirstOfMonth()"
				data-testid="create-checklists-checklist-term-type">
				<option value="1">Monthly</option>
				<option value="3">Quarterly</option>
			</select>
			<div class="col-1">
				<span *ngIf="checklistEndDate">
					{{ checklistEndDate | date : shortdate }}
				</span>
			</div>
			<div class="col-1">
				<span *ngIf="checklistDueDate">
					{{ checklistDueDate | date : shortdate }}
				</span>
			</div>
			<button type="button" class="btn btn-primary btn-sm" (click)="createIftaMilesFuelChecklist()"
				data-testid="create-checklists-create-ifta-miles-fuel">
				Create IFTA miles/fuel checklist
			</button>
		</div>
		<hr />
		<div class="row m-1" *ngIf="!isRunningChecklistBuild">
			<div class="col-2 text-right">IFTA Quarterly Filing</div>
			<select class="col-2" [(ngModel)]="checklistUseOneCompany" data-testid="create-checklists-company-scope">
				<option [ngValue]="true">One Company</option>
				<option [ngValue]="false">Many Companies</option>
			</select>
			<input class="col-1" *ngIf="checklistUseOneCompany" type="number"
				[(ngModel)]="checklistIftaQuarterlyCompanyId"
				data-testid="create-checklists-checklist-ifta-quarterly-company-number" />
			<textarea class="col-1" *ngIf="!checklistUseOneCompany" [(ngModel)]="checklistIftaQuarterlyListOfCompanies"
				data-testid="create-checklists-checklist-ifta-quarterly-list"></textarea>
			<select class="col-1" [(ngModel)]="checklistIftaQuarterlyTermChecklist"
				data-testid="create-checklists-checklist-ifta-quarterly-term">
				<option value="0">Q1</option>
				<option value="1">Q2</option>
				<option value="2">Q3</option>
				<option value="3">Q4</option>
			</select>
			<input class="col-1" type="number" [(ngModel)]="checklistIftaQuarterlyYear"
				data-testid="create-checklists-checklist-ifta-quarterly-year-number" />
			<button type="button" class="btn btn-primary btn-sm" (click)="createIftaQuarterlyChecklist()"
				data-testid="create-checklists-create-ifta-quarterly-filing">
				Create IFTA Quarterly Filing Checklist
			</button>
		</div>
		<hr />
		<div class="row m-1" *ngIf="!isRunningChecklistBuild">
			<div class="col-2 text-right">IRP Renewal</div>
			<div class="col-2 text-center">-</div>
			<input class="col-1" *ngIf="checklistUseOneCompany" type="number" [(ngModel)]="irpCompanyId"
				data-testid="create-checklists-irp-company-id-number" />
			<div class="col-1 text-center">{{ irpMonth }}</div>
			<div class="col-1 text-center">-</div>
			<button type="button" class="btn btn-primary btn-sm" [disabled]="!checklistUseOneCompany"
				(click)="createIrpRenewalChecklist(false)" data-testid="create-checklists-create-irp-renewal-checklist">
				Create IRP Renewal Checklist
			</button>
		</div>
		<hr />
		<div class="row m-1" *ngIf="!isRunningChecklistBuild">
			<div class="col-2 text-right">UCR Filing</div>
			<div class="col-2 text-center">-</div>
			<input class="col-1" *ngIf="checklistUseOneCompany" type="number" [(ngModel)]="ucrCompanyId"
				data-testid="create-checklists-ucr-company-id-number" />
			<div class="col-1 text-center">-</div>
			<input class="col-1" *ngIf="checklistUseOneCompany" type="number" [(ngModel)]="ucrYear"
				data-testid="create-checklists-ucr-year-number" />
			<button type="button" class="btn btn-primary btn-sm" [disabled]="!checklistUseOneCompany"
				(click)="createUcrChecklist(false)" data-testid="create-checklists-create-ucr-filing-checklist">
				Create UCR Filing Checklist
			</button>
		</div>
		<hr />
		<div class="row m-1" *ngIf="!isRunningChecklistBuild">
			<div class="col-2 text-right">SCAC Filing</div>
			<div class="col-2 text-center">-</div>
			<input class="col-1" *ngIf="checklistUseOneCompany" type="number" [(ngModel)]="scacCompanyId"
				data-testid="create-checklists-scac-company-id-number" />
			<div class="col-1 text-center">-</div>
			<input class="col-1" *ngIf="checklistUseOneCompany" type="number" [(ngModel)]="scacYear"
				data-testid="create-checklists-scac-year-number" />
			<button type="button" class="btn btn-primary btn-sm" [disabled]="!checklistUseOneCompany"
				(click)="createSCACChecklist(false)" data-testid="create-checklists-create-scac-filing-checklist">
				Create SCAC Filing Checklist
			</button>
		</div>
		<hr />
		<div class="row m-1" *ngIf="!isRunningChecklistBuild">
			<div class="col-2 text-right">NM MTR Renewal</div>
			<div class="col-2 text-center">-</div>
			<input class="col-1" *ngIf="checklistUseOneCompany" type="number" [(ngModel)]="nmMTRCompanyId"
				data-testid="create-checklists-nmmtr-company-id-number" />
			<div class="col-1 text-center">-</div>
			<input class="col-1" *ngIf="checklistUseOneCompany" type="number" [(ngModel)]="nmMTRYear"
				data-testid="create-checklists-nmmtr-year-number" />
			<button type="button" class="btn btn-primary btn-sm" [disabled]="!checklistUseOneCompany"
				(click)="createNMMTRRenewalChecklist(false)" data-testid="create-checklists-create-nmmtr-filing-checklist">
				Create NM MTR Renewal Checklist
			</button>
		</div>
		<hr />
		<div class="row m-1" *ngIf="!isRunningChecklistBuild">
			<div class="col-2 text-right">HAZMAT Filing</div>
			<div class="col-2 text-center">-</div>
			<input class="col-1" *ngIf="checklistUseOneCompany" type="number" [(ngModel)]="hazmatCompanyId"
				data-testid="create-checklists-hazmat-company-id-number" />
			<div class="col-1 text-center">-</div>
			<input class="col-1" *ngIf="checklistUseOneCompany" type="number" [(ngModel)]="hazmatYear"
				data-testid="create-checklists-hazmat-year-number" />
			<button type="button" class="btn btn-primary btn-sm" [disabled]="!checklistUseOneCompany"
				(click)="createHAZMATChecklist(false)" data-testid="create-checklists-create-hazmat-filing-checklist">
				Create HAZMAT Filing Checklist
			</button>
		</div>
		<hr />
		<div class="row m-1" *ngIf="!isRunningChecklistBuild">
			<div class="col-2 text-right">NY HUT Renewal</div>
			<div class="col-2 text-center">-</div>
			<input class="col-1" *ngIf="checklistUseOneCompany" type="number" [(ngModel)]="nyHutCompanyId"
				data-testid="create-checklists-ny-hut-company-id-number" />
			<div class="col-1 text-center">-</div>
			<input class="col-1" *ngIf="checklistUseOneCompany" type="number" [(ngModel)]="nyHutYear"
				data-testid="create-checklists-ny-hut-year-number" />
			<button type="button" class="btn btn-primary btn-sm" [disabled]="!checklistUseOneCompany"
				(click)="createNyHutRenewalChecklistSingle()" data-testid="create-checklists-create-ny-hut-renewal">
				Create NY HUT Renewal Checklist
			</button>
		</div>

		<div class="text-primary" role="status" *ngIf="isRunningChecklistBuild">
			<i class="fa-duotone fa-2x m-2" [ngClass]="
					checklistLoading > 0
						? 'fa-starship-freighter text-primary'
						: 'fa-starfighter-twin-ion-engine text-danger'
				" *ngIf="!checklistUseOneCompany"></i>
			<i class="fa-duotone fa-2x m-2" [ngClass]="
					checklistLoading > 0.1
						? 'fa-starfighter text-primary fa-rotate-90'
						: 'fa-starfighter-twin-ion-engine text-danger'
				" *ngIf="!checklistUseOneCompany"></i>
			<i class="fa-duotone fa-2x m-2" [ngClass]="
					checklistLoading > 0.2
						? 'fa-starfighter text-primary fa-rotate-90'
						: 'fa-starfighter-twin-ion-engine text-danger'
				" *ngIf="!checklistUseOneCompany"></i>
			<i class="fa-duotone fa-2x m-2" [ngClass]="
					checklistLoading > 0.3
						? 'fa-starfighter text-primary fa-rotate-90'
						: 'fa-starfighter-twin-ion-engine text-danger'
				" *ngIf="!checklistUseOneCompany"></i>
			<i class="fa-duotone fa-2x m-2" [ngClass]="
					checklistLoading > 0.4
						? 'fa-starfighter text-primary fa-rotate-90'
						: 'fa-starfighter-twin-ion-engine text-danger'
				" *ngIf="!checklistUseOneCompany"></i>
			<i class="fa-duotone fa-2x m-2" [ngClass]="
					checklistLoading > 0.5
						? 'fa-starfighter text-primary fa-rotate-90'
						: 'fa-starfighter-twin-ion-engine text-danger'
				" *ngIf="!checklistUseOneCompany"></i>
			<i class="fa-duotone fa-2x m-2" [ngClass]="
					checklistLoading > 0.6
						? 'fa-starfighter text-primary fa-rotate-90'
						: 'fa-starfighter-twin-ion-engine text-danger'
				" *ngIf="!checklistUseOneCompany"></i>
			<i class="fa-duotone fa-2x m-2" [ngClass]="
					checklistLoading > 0.7
						? 'fa-starfighter text-primary fa-rotate-90'
						: 'fa-starfighter-twin-ion-engine text-danger'
				" *ngIf="!checklistUseOneCompany"></i>
			<i class="fa-duotone fa-2x m-2" [ngClass]="
					checklistLoading > 0.8
						? 'fa-starfighter text-primary fa-rotate-90'
						: 'fa-starfighter-twin-ion-engine text-danger'
				" *ngIf="!checklistUseOneCompany"></i>
			<i class="fa-duotone fa-2x m-2" [ngClass]="
					checklistLoading > 0.9
						? 'fa-starship text-primary'
						: 'fa-starfighter-twin-ion-engine text-danger'
				" *ngIf="!checklistUseOneCompany"></i>
			<i class="fa-solid fa-space-station-moon-construction fa-spin fa-3x"></i>
			<span class="m-2" *ngIf="!checklistUseOneCompany">....{{ checklistLoading | percent }}</span>
		</div>
		<hr />
	</div>
</div>


// WEBPACK FOOTER //
// ./src/app/developer/components/developer-tools/create-checklists/create-checklists.component.html